import merge from 'lodash/merge';
import { el as elGrAdapter, enUS as enUSAdapter } from 'date-fns/locale';

// core
import { enUS as enUSCore, elGR as elGrCore } from '@mui/material/locale';
// date-pickers
import { enUS as enUSDate, elGR as elGrDate } from '@mui/x-date-pickers/locales';
// data-grid
// eslint-disable-next-line import/no-extraneous-dependencies
import { enUS as enUSDataGrid, elGR as elGrDataGrid } from '@mui/x-data-grid/locales';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
  },
  {
    label: 'Greek',
    value: 'el',
    systemValue: merge(elGrDate, elGrDataGrid, elGrCore),
    adapterLocale: elGrAdapter,
    icon: 'flagpack:gr',
  },
];

export const defaultLang = allLangs[0]; // English

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
